var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v(" Szczegóły kodu ")]),_c('v-card-text',[_c('AddCode',{attrs:{"code":this.code}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }